const footer = {
  links: [],
  copyright: '2021 - PT TrawlBens Teknologi Anak Indonesia'
}

export default footer
